export function IconHeartHandshake() {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5.35999L12.77 4.57999C13.2716 4.07656 13.8678 3.67713 14.5241 3.40458C15.1805 3.13203 15.8842 2.99173 16.595 2.99173C17.3057 2.99173 18.0094 3.13203 18.6658 3.40458C19.3222 3.67713 19.9183 4.07656 20.42 4.57999C22.54 6.69999 22.67 10.28 20 13L12 21L3.99996 13C1.32996 10.28 1.45996 6.69999 3.57996 4.57999C4.08164 4.07656 4.67776 3.67713 5.33414 3.40458C5.99052 3.13203 6.69425 2.99173 7.40496 2.99173C8.11568 2.99173 8.81941 3.13203 9.47578 3.40458C10.1322 3.67713 10.7283 4.07656 11.23 4.57999L12 5.35999ZM12 5.35999L8.86996 8.49999C8.47425 8.89893 8.25221 9.43808 8.25221 9.99999C8.25221 10.5619 8.47425 11.101 8.86996 11.5C9.26891 11.8957 9.80805 12.1177 10.37 12.1177C10.9319 12.1177 11.471 11.8957 11.87 11.5L14.13 9.28999C14.6916 8.73427 15.4498 8.42257 16.24 8.42257C17.0301 8.42257 17.7883 8.73427 18.35 9.28999L20.75 11.69M18 15L16 13M15 18L13 16"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        vectorEffect="non-scaling-size"
      />
    </svg>
  );
}
